import { determinePlatform, Platform } from 'shared/engine-dynamic';

import upp from 'app/app.module';

class UrlResolverService {

    static $inject = [ 'config' ];
    constructor(config) {
        config.getWebAppURL().then((webappUrl) => {
            const url = new URL(webappUrl);
            this._childuppHostname = url.hostname;
        });
    }

    /**
     * Hostname of the currently running app.
     * @private
     * @type {string}
     */
    _childuppHostname = '';

    /**
     * Opens the given url. Depending on the url hostname it will be opened
     * on the current window or a new one.
     * @param  {string} url The url to be opened
     * @return {void}
     */
    open(url) {
        // If we dont have the hostname yet, assume it is external.
        // This should never happen while normal application usage.
        if (!this._childuppHostname) {
            window.open(url, '_system');
            return;
        }

        // Special links needs to open in same window
        const reservedSchemes = ["tel:", "mailto:", "sms:"];
        if (reservedSchemes.find((e) => url.startsWith(e))) {
            window.location.assign(url);
            return;
        }

        const resolvedUrl = this.resolve(url);
        const nextUrl = new URL(resolvedUrl, window.location);
        if (
            /^https?:$/.test(nextUrl.protocol)
            &&
            (!nextUrl.hostname || nextUrl.hostname === this._childuppHostname)
        ) {
            window.location.assign(nextUrl.hash);
        } else {
            window.open(nextUrl.href, '_system');
        }
    }

    /**
     * Modifies the url based on the current platform.
     * @param  {string} url The url to be resolved
     * @return {string}
     */
    resolve(url = '') {
        if (!url) {
            throw new TypeError('No url provided');
        }
        const parsedUrl = new URL(url);
        const platform = determinePlatform();
        if (platform === Platform.IOS && /maps\.google\.[a-z]+/.test(parsedUrl.hostname)) {
            parsedUrl.hostname = parsedUrl.hostname.replace(/maps\.google\.[a-z]+/, 'maps.apple.com');
        }
        return parsedUrl.href;
    }
}

upp.service('urlResolver', UrlResolverService);



// WEBPACK FOOTER //
// ./src/app/common/services/url-resolver-service.js